import { Autoplay, Controller, EffectFade, Navigation, Pagination, Thumbs, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Thumbs, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  if (document.getElementById('topInfor')) {
    const topInfor = document.getElementById('topInfor')

    const topInforSwiper = new Swiper(topInfor, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true,
      slidesPerView: 1.1,
      spaceBetween: 10,
      centeredSlides: false,

      autoplay: {
        // オートオプション
        delay: 6000, // 待機時間
        disableOnInteraction: true, // 操作されたら停止する
        pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
        stopOnLastSlide: true, // 最終スライドに到達したら停止する
      },
      navigation: {
        nextEl: '.swiper-button-next--info',
        prevEl: '.swiper-button-prev--info',
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--info', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true,
      },
      breakpoints: {
        // 指定px以上でオプション切り替え

        769: {
          spaceBetween: 20,
          slidesPerView: 2, // 何列表示にするか
          centeredSlides: false,
        },
      },
      on: {
        // イベントを登録する
        slideChange: (swiper) => {
          let slideCurrentIndex = swiper.realIndex // get current slide's index
          if (slideCurrentIndex == 1) {
            setTimeout(function () {
              let scrollHint = document.querySelectorAll('.scroll-hint-icon-wrap')
              scrollHint[1].classList.remove('is-active')
            }, 2000)
          }
        },
        touchEnd: (swiper) => {
          let scrollHint = document.querySelectorAll('.scroll-hint-icon-wrap')
          scrollHint[1].classList.remove('is-active')
        },
      },
    })
  }
}

if (document.getElementById('topPickup')) {
  const PickupSlide = document.getElementById('topPickup')

  const topPickSwiper = new Swiper(PickupSlide, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true,
    slidesPerView: 1.8,
    spaceBetween: 10,
    centeredSlides: false,

    autoplay: {
      // オートオプション
      delay: 6000, // 待機時間
      disableOnInteraction: true, // 操作されたら停止する
      pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
      stopOnLastSlide: true, // 最終スライドに到達したら停止する
    },
    navigation: {
      nextEl: '.swiper-button-next--pickup',
      prevEl: '.swiper-button-prev--pickup',
    },
    pagination: {
      // ページャーオプション
      el: '.swiper-pagination--pickup', // ページャーを呼び出す要素
      type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
      clickable: true,
    },
    breakpoints: {
      // 指定px以上でオプション切り替え

      769: {
        spaceBetween: 20,
        slidesPerGroup: 4,
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
    on: {
      // イベントを登録する
      slideChange: (swiper) => {
        let slideCurrentIndex = swiper.realIndex // get current slide's index
        if (slideCurrentIndex == 1) {
          setTimeout(function () {
            let scrollHint = document.querySelectorAll('.scroll-hint-icon-wrap')
            scrollHint[0].classList.remove('is-active')
          }, 2000)
        }
      },
      touchEnd: (swiper) => {
        let scrollHint = document.querySelectorAll('.scroll-hint-icon-wrap')
        if (scrollHint.length > 0) {
          scrollHint[0].classList.remove('is-active')
        }
      },
    },
  })
}

/*
###     ###  ##     ##  ######     ####      ######   #######
## ## ## ##   ##   ##   ##   ##  ##    ##  ##         ##
##  ###  ##     ###     ######   ########  ##   ####  ######
##       ##     ##      ##       ##    ##  ##     ##  ##
##       ##     ##      ##       ##    ##    ######   #######
*/

if (document.getElementsByClassName('js-mypage-slider')[0]) {
  const myPageSlider = new Swiper('.js-mypage-slider', {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: false,
    slidesPerView: 1.8,
    spaceBetween: 10,
    centeredSlides: false,

    autoplay: {
      // オートオプション
      delay: 6000, // 待機時間
      disableOnInteraction: true, // 操作されたら停止する
      // pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
      // stopOnLastSlide: true, // 最終スライドに到達したら停止する
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      // ページャーオプション
      el: '.swiper-pagination', // ページャーを呼び出す要素
      type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
      clickable: true,
    },
    breakpoints: {
      // 指定px以上でオプション切り替え

      769: {
        spaceBetween: 20,
        slidesPerGroup: 4,
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
  })
}

if (document.getElementsByClassName('js_job-single')[0]) {
  const job_Thumbs = new Swiper('.singleJob__thumb', {
    //loop: true, ループを有効にしない
    slidesPerView: 5,
    spaceBetween: 10,
    //各スライドの進行状況を監視
    watchSlidesProgress: true,
    //ビューポートにあるスライドに表示クラスを追加
    watchSlidesVisibility: true,
    //カーソルをデフォルトから grab に変更
    grabCursor: true,
  })

  const job_ImageSlider = new Swiper('.js_job-single', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    thumbs: {
      //サムネイルのスライダーを指定
      swiper: job_Thumbs,
    },
  })
}

//==========================================================
//
//  ######   #####    #####   ##      ######  ##  #####
//    ##    ##   ##  ##   ##  ##        ##    ##  ##  ##
//    ##    ##   ##  ##   ##  ##        ##    ##  #####
//    ##    ##   ##  ##   ##  ##        ##    ##  ##
//    ##     #####    #####   ######    ##    ##  ##
//
//==========================================================
document.addEventListener('DOMContentLoaded', function () {
  // <a href="" class="js-tooltip" data-tooltip="tooltip">Text Link</a>
  if (document.getElementsByClassName('js-tooltip')[0]) {
    const buttons = document.querySelectorAll('.js-tooltip')

    // SPデバイスの判定する
    function isMobile() {
      return /Mobi|Android/i.test(navigator.userAgent)
    }

    buttons.forEach((button) => {
      // tooltip要素を作成する
      const tooltip = document.createElement('div')
      tooltip.className = 'tooltip'
      tooltip.style.display = 'none'
      tooltip.textContent = button.getAttribute('data-tooltip')
      button.appendChild(tooltip)

      button.addEventListener('click', function (event) {
        const tooltip = this.querySelector('.tooltip')
        if (!isMobile()) {
          // PCの場合
          event.preventDefault()
          tooltip.style.display = 'block'
        }
      })
    })

    // 他の場所にクリックしたとき tooltip を非表示にする
    document.addEventListener('click', (e) => {
      if (!e.target.classList.contains('js-tooltip')) {
        document.querySelectorAll('.tooltip').forEach((tooltip) => {
          tooltip.style.display = 'none'
        })
      }
    })
  }
})
